export default __webpack_public_path__ + "static/media/12_tag_convenience-store.2bac3762.svg";